/**
 * @copyright NIIT Technologies Ltd. 2017-18.
 */

// Angular
import { NgModule } from '@angular/core';

// NGC Container Controls

/**
 * NGC Container Module
 */
@NgModule({
    exports: [
    ]
})
export class NgcContainerModule {
}